(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lahna-article-products"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lahna-article-shelf')) {
    customElements.define('lahna-article-shelf', class extends HTMLElement {
      connectedCallback() {
        const list = this.querySelector('ul');
        const controls = this.querySelector('.lahna-article-shelf__controls');
        const buttons = Array.from(controls.querySelectorAll('button'));
        const refresh = () => {
          const max = list.scrollWidth - list.clientWidth;
          controls.hidden = max < 2;
          buttons[0].disabled = list.scrollLeft < 2;
          buttons[1].disabled = list.scrollLeft >= max - 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => list.scrollBy({left: Number(button.dataset.direction) * list.clientWidth * .8, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'})));
        list.addEventListener('scroll', refresh, {passive:true});
        this.observer = new ResizeObserver(refresh);
        this.observer.observe(list);
        refresh();
      }
      disconnectedCallback() { this.observer?.disconnect(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-cart-feedback"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lahna-cart-feedback')) {
    customElements.define('lahna-cart-feedback', class extends HTMLElement {
      connectedCallback() {
        this.items = JSON.parse(this.querySelector('[data-cart-initial]').textContent);
        this.toast = this.querySelector('[data-cart-toast]');
        this.version = 0;
        this.start = () => {
          this.unsubscribeCart = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => this.refresh(event.source === 'product-form'));
          this.unsubscribeError = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
            clearTimeout(this.timer);
            this.querySelector('[data-cart-toast-message]').textContent = typeof event.errors === 'string' ? event.errors : window.cartStrings.error;
            this.toast.hidden = false;
            this.timer = setTimeout(() => { if (!this.toast.contains(document.activeElement)) this.toast.hidden = true; }, 8000);
          });
          this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, () => this.render());
          this.render();
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.start, {once:true}); else this.start();
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('product-form') || node.querySelector('product-form'))))) this.render();
        });
        this.observer.observe(document.querySelector('main'), {childList:true, subtree:true});
        this.onCartLink = (event) => {
          const link = event.target.closest('[data-feedback-cart-link]');
          const drawer = document.querySelector('cart-drawer');
          if (!link || !drawer || event.ctrlKey || event.metaKey) return;
          event.preventDefault();
          drawer.open(link);
          this.toast.hidden = true;
        };
        document.addEventListener('click', this.onCartLink);
        this.onPageShow = (event) => { if (event.persisted) this.refresh(false); };
        window.addEventListener('pageshow', this.onPageShow);
      }
      disconnectedCallback() {
        this.unsubscribeCart?.(); this.unsubscribeError?.(); this.unsubscribeVariant?.(); this.observer?.disconnect();
        document.removeEventListener('click', this.onCartLink);
        document.removeEventListener('DOMContentLoaded', this.start);
        window.removeEventListener('pageshow', this.onPageShow);
        clearTimeout(this.timer);
      }
      async refresh(added) {
        const version = ++this.version;
        try {
          const response = await fetch(`${window.routes.cart_url}.js`, {headers:{Accept:'application/json'}});
          if (!response.ok) return;
          const cart = await response.json();
          if (version !== this.version) return;
          this.items = cart.items.map(item => ({id:item.variant_id, quantity:item.quantity}));
          this.render();
          if (added) {
            this.querySelector('[data-cart-toast-message]').textContent = `✓ ${this.dataset.added}`;
            this.toast.hidden = false;
            clearTimeout(this.timer);
            this.timer = setTimeout(() => { if (!this.toast.contains(document.activeElement)) this.toast.hidden = true; }, 5000);
          }
        } catch (_) {}
      }
      render() {
        document.querySelectorAll('product-form').forEach(form => {
          const id = Number(form.querySelector('[name="id"]')?.value);
          const quantity = this.items.filter(item => item.id === id).reduce((sum,item) => sum + item.quantity, 0);
          let status = form.querySelector('.lahna-added-status');
          if (!status && quantity) {
            status = document.createElement('div'); status.className = 'lahna-added-status';
            const label = document.createElement('span'); label.dataset.cartQuantity = '';
            const link = document.createElement('a'); link.href = this.dataset.cartUrl;
            link.dataset.feedbackCartLink = ''; link.textContent = this.dataset.view;
            status.append(label,link); form.append(status);
          }
          if (!status) return;
          status.hidden = !quantity;
          status.querySelector('[data-cart-quantity]').textContent = `✓ ${this.dataset.inCart.replace('[count]',quantity)}`;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-catalogue-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lahna-catalogue-filters')) customElements.define('lahna-catalogue-filters', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.intro = this.closest('.lahna-collection-intro');
    this.activeChips = this.intro.querySelector('[data-lahna-active-filters]');
    this.clear = this.intro.querySelector('[data-catalogue-reset]');
    this.links = [...this.intro.querySelectorAll('[data-catalogue-collection]')];
    this.panels = [...this.intro.querySelectorAll('.lahna-catalogue-bar details')];
    this.collectionControl = this.intro.querySelector('[data-collection-summary]');
    this.collectionInputs = [...this.intro.querySelectorAll('[data-collection-option]')];
    this.collectionInputs.forEach(input => input.addEventListener('change', () => {
      this.updateCollectionCount();
      this.navigate(this.collectionUrl(), true, false, true);
    }, options));
    this.intro.querySelector('[data-collection-done]')?.addEventListener('click', () => {
      this.close();
      this.collectionControl.focus();
    }, options);
    this.intro.querySelector('[data-collection-reset]')?.addEventListener('click', () => {
      this.collectionInputs.forEach(input => { input.checked = false; });
      this.navigate(this.collectionUrl(), true, false, true);
    }, options);
    this.intro.querySelectorAll('.lahna-motif-links a').forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      const current = new URL(location.href);
      if (!['collection', 'couleur'].some(name => current.searchParams.has(name))) return;
      event.preventDefault();
      const target = new URL(link.href);
      ['collection', 'couleur', 'sort_by', 'preview_theme_id'].forEach(name => current.searchParams.getAll(name).forEach(value => target.searchParams.append(name,value)));
      location.assign(target.href);
    }, options));
    this.cache = new Map();
    this.filterLabels = JSON.parse(this.querySelector('[data-filter-labels]').textContent);
    this.activeChips.addEventListener('click', event => {
      const chip = event.target.closest('[data-remove-tag]');
      if (!chip) return;
      const input = this.filterInputs().find(input => input.value === chip.dataset.removeTag);
      if (input) {
        input.checked = false;
        if (input.name === 'collection') this.navigate(this.collectionUrl(),true);
        else this.apply(true);
      }
      (input?.name === 'collection' ? this.collectionControl : this.querySelector('summary')).focus();
    }, options);
    this.links.forEach(link => link.addEventListener('click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      const url = new URL(location.href);
      url.pathname = new URL(link.href).pathname;
      url.searchParams.delete('page');
      this.navigate(url, true);
      this.close();
      this.collectionControl.focus({ preventScroll:true });
    }, options));
    this.clear.addEventListener('click', event => { event.preventDefault(); this.reset(); }, options);
    this.addEventListener('change', () => this.apply(true), options);
    this.addEventListener('click', event => {
      if (event.target.closest('[data-filter-reset]')) this.reset();
      if (event.target.closest('[data-filter-done]')) {
        const details = event.target.closest('details'); details.open = false; details.querySelector('summary').focus();
      }
      if (event.target.closest('[data-filter-retry]')) this.navigate(this.retryUrl || new URL(location.href), true);
    }, options);
    this.panels.forEach(details => details.addEventListener('toggle', () => {
      if (details.open) this.panels.forEach(other => { if (other !== details) other.open = false; });
    }, options));
    document.addEventListener('click', event => { if (!this.intro.querySelector('.lahna-catalogue-bar').contains(event.target)) this.close(); }, options);
    this.intro.addEventListener('keydown', event => {
      if (event.key === 'Escape') { const open = this.panels.find(details => details.open); this.close(); open?.querySelector('summary').focus(); }
    }, options);
    window.addEventListener('popstate', () => this.navigate(new URL(location.href), false), options);
    const prepare = () => {
      this.grid = document.getElementById('product-grid');
      if (!this.grid) return;
      this.hidden = false;
      this.pageSize = 24;
      this.currentUrl = new URL(location.href);
      this.buildOptions();
      this.restore(this.currentUrl);
      if (this.hasFilters(this.currentUrl)) this.navigate(this.currentUrl, false, true);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { ...options, once:true });
    else prepare();
  }
  disconnectedCallback() { this.controller.abort(); this.request?.abort(); }
  filterInputs() { return [...this.querySelectorAll('input'), ...this.collectionInputs]; }
  hasFilters(url) { return ['couleur','motif','collection'].some(name => url.searchParams.has(name)); }
  updateCollectionCount() {
    const count = this.collectionInputs.filter(input => input.checked).length;
    const badge = this.intro.querySelector('[data-collection-count]');
    if (badge) { badge.textContent = count; badge.hidden = !count; }
  }
  collectionUrl() {
    const url = new URL(location.href);
    if (this.collectionInputs.some(input => new URL(input.dataset.collectionUrl,location.origin).pathname === url.pathname)) url.pathname = this.intro.dataset.allUrl;
    url.searchParams.delete('collection');
    this.collectionInputs.filter(input => input.checked).forEach(input => url.searchParams.append('collection',input.value));
    url.searchParams.delete('page');
    return url;
  }
  close() { this.panels.forEach(details => { details.open = false; }); }
  reset() {
    const url = new URL(this.intro.dataset.allUrl, location.origin);
    const current = new URL(location.href);
    ['sort_by','preview_theme_id'].forEach(key => { if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key)); });
    this.navigate(url, true);
    this.collectionControl.focus({ preventScroll:true });
  }
  key(url) {
    const key = new URL(url);
    ['couleur','motif','collection','page'].forEach(name => key.searchParams.delete(name));
    return key.href;
  }
  async load(url, initial, signal) {
    const key = this.key(url);
    if (this.cache.has(key)) return this.cache.get(key);
    let pages = 1;
    let titleNodes = [];
    let pageTitle = '';
    let pageMeta = { canonical: '', tags: [] };
    let sortOptions = '';
    let guideHtml = '';
    const cards = [];
    const productIds = new Set();
    for (let page = 1; page <= pages; page++) {
      let doc;
      if (initial && page === Number(this.grid.dataset.lahnaPage || 1)) doc = document;
      else {
        const endpoint = new URL(key); endpoint.searchParams.set('page', page);
        const response = await fetch(endpoint, { signal, credentials:'same-origin' });
        if (!response.ok) throw new Error('Collection unavailable');
        doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      }
      const grid = doc.querySelector('#product-grid');
      if (!grid) throw new Error('Collection unavailable');
      pages = Number(grid.dataset.lahnaPages || 1);
      if (page === 1) {
        titleNodes = [...(doc.querySelector('.lahna-collection-intro h1')?.childNodes || [])].map(node => node.cloneNode(true));
        pageTitle = doc.title;
        pageMeta = {
          canonical: doc.querySelector('link[rel="canonical"]')?.getAttribute('href') || '',
          tags: [
            'meta[name="description"]',
            'meta[property="og:url"]',
            'meta[property="og:title"]',
            'meta[property="og:description"]',
            'meta[name="twitter:title"]',
            'meta[name="twitter:description"]'
          ].map(selector => ({ selector, content: doc.querySelector(selector)?.getAttribute('content') ?? null }))
        };
        guideHtml = doc.querySelector('[data-lahna-collection-guide]')?.innerHTML || '';
        sortOptions = doc.querySelector('lahna-collection-tools select')?.innerHTML || '';
      }
      grid.querySelectorAll(':scope > [data-lahna-attributes]').forEach(source => {
        const productId = source.dataset.lahnaProductId;
        if (productId && productIds.has(productId)) return;
        if (productId) productIds.add(productId);
        const node = source.cloneNode(true);
        node.hidden = false;
        node.classList.remove('scroll-trigger','animate--slide-in');
        node.querySelectorAll('script').forEach(script => script.remove());
        cards.push(node.outerHTML);
      });
    }
    const result = { cards, titleNodes, pageTitle, pageMeta, sortOptions, guideHtml };
    this.cache.set(key, result);
    return result;
  }
  async navigate(url, push, initial = false, keepOpen = false) {
    if (!this.grid) return;
    if (!this.hasFilters(url)) {
      location.assign(url.href);
      return;
    }
    this.request?.abort();
    const request = this.request = new AbortController();
    if (!keepOpen) this.close();
    this.retryUrl = url;
    this.querySelector('[data-filter-error]').hidden = true;
    this.querySelector('[data-filter-loading]').hidden = false;
    this.grid.setAttribute('aria-busy','true');
    this.querySelectorAll('input').forEach(input => { input.disabled = true; });
    try {
      const result = await this.load(url, initial, request.signal);
      if (request.signal.aborted) return;
      if (this.grid.tagName !== 'UL') { location.assign(url); return; }
      const template = document.createElement('template');
      template.innerHTML = result.cards.join('');
      this.items = [...template.content.querySelectorAll('[data-lahna-attributes]')].map(node => {
        const attributes = JSON.parse(node.dataset.lahnaAttributes);
        const tags = new Set(['motif','couleur'].flatMap(group => (attributes[group] || []).map(label => this.token(group,label))));
        return { node, attributes, tags, collections:new Set(JSON.parse(node.dataset.lahnaCollections || '[]')) };
      });
      this.buildOptions();
      this.intro.querySelector('h1').replaceChildren(...result.titleNodes.map(node => node.cloneNode(true)));
      document.title = result.pageTitle;
      if (result.pageMeta.canonical) {
        document.querySelector('link[rel="canonical"]')?.setAttribute('href', result.pageMeta.canonical);
      }
      result.pageMeta.tags.forEach(({ selector, content }) => {
        const existing = document.querySelector(selector);
        if (content === null) {
          if (existing) existing.remove();
          return;
        }
        if (existing) {
          existing.setAttribute('content', content);
        } else {
          const meta = document.createElement('meta');
          const attribute = selector.includes('[property=') ? 'property' : 'name';
          meta.setAttribute(attribute, selector.split('"')[1]);
          meta.setAttribute('content', content);
          document.head.appendChild(meta);
        }
      });
      const guide = document.querySelector('[data-lahna-collection-guide]');
      if (guide) guide.innerHTML = result.guideHtml;
      this.intro.querySelector('lahna-collection-tools form')?.setAttribute('action',url.pathname);
      const sort = this.intro.querySelector('[name=sort_by]');
      if (sort && result.sortOptions) sort.innerHTML = result.sortOptions;
      if (sort && url.searchParams.has('sort_by')) sort.value = url.searchParams.get('sort_by');
      this.links.forEach(link => {
        const active = new URL(link.href).pathname === url.pathname || (url.pathname.endsWith('/frontpage') && link === this.links[0]);
        if (active) link.setAttribute('aria-current','page'); else link.removeAttribute('aria-current');
      });
      this.updateCollectionCount();
      if (push && url.href !== location.href) history.pushState({},'',url);
      this.currentUrl = url;
      this.restore(url);
      this.apply(false);
      document.querySelector('#ProductGridContainer .pagination-wrapper')?.setAttribute('hidden','');
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.querySelector('[data-filter-error]').hidden = false;
        this.apply(false);
      }
    } finally {
      if (this.request === request) {
        if (!this.items) this.querySelectorAll('input').forEach(input => { input.disabled = false; });
        this.querySelector('[data-filter-loading]').hidden = true;
        this.grid.removeAttribute('aria-busy');
      }
    }
  }
  token(group,label) {
    const slug = value => value.toLowerCase().replaceAll('œ','oe').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
    const value = slug(label);
    // Keep filter URLs stable when Shopify translates the product metafield values.
    const translated = Object.entries(this.filterLabels).find(([key,text]) => key.startsWith(group + '-') && slug(text) === value);
    return translated ? translated[0] : group + '-' + value;
  }
  buildOptions() {
    this.querySelectorAll('[data-filter-group]').forEach(field => {
      const group = field.dataset.filterGroup;
      field.querySelectorAll('label').forEach(label => label.remove());
      const labels = [...new Set([...Object.entries(this.filterLabels).filter(([key]) => key.startsWith(group + '-')).map(([,label]) => label), ...(this.items || []).flatMap(item => item.attributes[group] || [])])].sort((a,b) => a.localeCompare(b,document.documentElement.lang || 'fr'));
      labels.forEach(text => {
        const token = this.token(group,text);
        const label = document.createElement('label');
        const input = document.createElement('input');
        input.type = 'checkbox'; input.name = group; input.value = token;
        input.id = 'LahnaFilter-' + this.dataset.sectionId + '-' + token;
        label.htmlFor = input.id;
        const caption = document.createElement('span'); caption.textContent = this.filterLabels[token] || text;
        const count = document.createElement('span'); count.className = 'lahna-filters__option-count'; count.dataset.optionCount = token;
        label.append(input,caption,count); field.append(label);
      });
    });
  }
  restore(url) {
    this.querySelectorAll('input').forEach(input => { input.checked = url.searchParams.getAll(input.name).map(value => value === 'couleur-creme' ? 'couleur-creme-beige' : value).includes(input.value); });
    const collections = url.searchParams.getAll('collection');
    this.collectionInputs.forEach(input => {
      input.checked = collections.length ? collections.includes(input.value) : new URL(input.dataset.collectionUrl,location.origin).pathname === url.pathname;
    });
    this.updateCollectionCount();
  }
  apply(updateUrl) {
    if (!this.items) {
      if (updateUrl) {
        const url = new URL(location.href);
        ['couleur','motif','collection'].forEach(group => { url.searchParams.delete(group); this.filterInputs().filter(input => input.name === group && input.checked).forEach(input => url.searchParams.append(group,input.value)); });
        url.searchParams.delete('page');
        this.navigate(url,true);
      }
      return;
    }
    const selected = Object.fromEntries(['couleur','motif','collection'].map(group => [group, this.filterInputs().filter(input => input.name === group && input.checked).map(input => input.value)]));
    const matches = (item, group) => !selected[group].length || selected[group].some(tag => (group === 'collection' ? item.collections : item.tags).has(tag));
    const filtered = this.items.filter(item => matches(item,'couleur') && matches(item,'motif') && matches(item,'collection'));
    const count = filtered.length;
    const pages = Math.max(1,Math.ceil(count / this.pageSize));
    const requestedPage = updateUrl ? 1 : Number((this.currentUrl || new URL(location.href)).searchParams.get('page'));
    const page = Math.min(pages,Math.max(1,Number.isInteger(requestedPage) ? requestedPage : 1));
    const start = (page - 1) * this.pageSize;
    this.grid.replaceChildren(...filtered.slice(start,start + this.pageSize).map(item => item.node));
    const label = this.dataset.countLabel.replace('[count]',count);
    document.querySelectorAll('[data-lahna-product-count]').forEach(node => { node.textContent = label; });
    this.querySelector('[data-filter-status]').textContent = label;
    this.querySelector('[data-filter-empty]').hidden = count > 0;
    const active = selected.couleur.length + selected.motif.length + selected.collection.length;
    this.activeChips.replaceChildren();
    this.filterInputs().filter(input => input.checked).forEach(input => {
      const label = input.closest('label').querySelector(input.name === 'collection' ? '[data-collection-label]' : 'input + span').textContent.trim();
      const chip = document.createElement('button');
      chip.type = 'button'; chip.dataset.removeTag = input.value; chip.textContent = label + ' ×';
      chip.setAttribute('aria-label',this.activeChips.dataset.removeLabel.replace('[label]',label));
      this.activeChips.append(chip);
    });
    this.activeChips.hidden = !active;
    const path = (this.currentUrl || new URL(location.href)).pathname;
    const allCollections = path === this.intro.dataset.allUrl || path.endsWith('/frontpage');
    this.clear.hidden = !active && allCollections;

    this.querySelectorAll('[data-selected-count]').forEach(node => { const n = selected[node.dataset.selectedCount].length; node.hidden = !n; node.textContent = n; });
    this.querySelectorAll('input').forEach(input => {
      const other = input.name === 'couleur' ? 'motif' : 'couleur';
      const n = this.items.filter(item => item.tags.has(input.value) && matches(item,other) && matches(item,'collection')).length;
      input.disabled = !n && !input.checked;
      input.closest('label').hidden = !n && !input.checked;
      input.closest('label').querySelector('[data-option-count]').textContent = n;
    });
    if (updateUrl) {
      const url = new URL(location.href);
      ['couleur','motif','collection'].forEach(group => { url.searchParams.delete(group); selected[group].forEach(value => url.searchParams.append(group,value)); });
      url.searchParams.delete('page');
      if (url.href !== location.href) history.pushState({},'',url);
      this.currentUrl = url;
      if (!this.hasFilters(url)) location.assign(url.href);
    }
    this.renderPagination(page,pages,count,start);
    document.dispatchEvent(new Event('lahna:catalogue-updated'));
  }
  renderPagination(page,pages,count,start) {
    this.pagination?.remove();
    if (!count) return;
    const nav = document.createElement('nav');
    nav.className = 'lahna-filter-pagination';
    nav.setAttribute('aria-label',this.dataset.pagination);
    const summary = document.createElement('p');
    summary.textContent = this.dataset.showing.replace('[start]',start + 1).replace('[end]',Math.min(start + this.pageSize,count)).replace('[total]',count);
    nav.append(summary);
    const addLink = (target,label) => {
      const url = new URL(this.currentUrl || location.href);
      url.searchParams.set('page',target);
      const node = document.createElement(target === page ? 'span' : 'a');
      node.textContent = label;
      if (target === page) node.setAttribute('aria-current','page');
      else {
        node.href = url.href;
        node.addEventListener('click',event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          history.pushState({},'',url);
          this.currentUrl = url;
          this.apply(false);
          this.grid.setAttribute('tabindex','-1');
          this.grid.focus({preventScroll:true});
          this.grid.scrollIntoView({block:'start',behavior:'instant'});
        });
      }
      nav.append(node);
    };
    if (page > 1) addLink(page - 1,this.dataset.previous);
    for (let p = 1; p <= pages; p++) {
      if (p === 1 || p === pages || Math.abs(p-page) <= 1) addLink(p,String(p));
      else if (Math.abs(p-page) === 2) { const dots = document.createElement('span'); dots.textContent = '…'; nav.append(dots); }
    }
    if (page < pages) addLink(page + 1,this.dataset.next);
    this.grid.after(nav);
    this.pagination = nav;
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-catalogue-view"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lahna-catalogue-view')) customElements.define('lahna-catalogue-view', class extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.buttons = [...this.querySelectorAll('[data-catalogue-view]')];
    const prepare = () => {
      if (!document.getElementById('product-grid')) return;
      let view = 'small';
      try { view = localStorage.getItem('lahna-catalogue-view') || view; } catch (_) { /* Storage may be unavailable. */ }
      this.apply(view);
      this.hidden = false;
    };
    this.addEventListener('click', event => {
      const button = event.target.closest('[data-catalogue-view]');
      if (!button) return;
      this.apply(button.dataset.catalogueView);
      try { localStorage.setItem('lahna-catalogue-view', button.dataset.catalogueView); } catch (_) { /* Keep the current view for this page. */ }
    }, options);
    document.addEventListener('lahna:catalogue-updated', () => this.apply(document.documentElement.dataset.lahnaCatalogueView), options);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepare, { ...options, once:true });
    else prepare();
  }
  apply(value) {
    const view = ['small', 'large', 'list'].includes(value) ? value : 'small';
    document.documentElement.dataset.lahnaCatalogueView = view;
    this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.catalogueView === view)));
    document.querySelectorAll('#product-grid .lahna-card-slide img').forEach(img => {
      img.sizes = view === 'list' ? '(min-width: 750px) 140px, 110px' : view === 'large' ? '(min-width: 750px) 50vw, 100vw' : '(min-width: 990px) 25vw, (min-width: 750px) 33vw, 50vw';
    });
  }
  disconnectedCallback() { this.controller?.abort(); }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-collection-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lahna-collection-tools')) customElements.define('lahna-collection-tools', class extends HTMLElement {

    connectedCallback() {

      this.form = this.querySelector('form');

      this.querySelector('[data-catalogue-apply]').hidden = true;

      this.onChange = () => {

        this.form.querySelectorAll('[data-lahna-filter-state]').forEach(input => input.remove());

        const params = new URLSearchParams(location.search);

        ['couleur', 'motif', 'collection', 'preview_theme_id'].forEach(name => params.getAll(name).forEach(value => {

          const input = document.createElement('input');

          input.type = 'hidden'; input.name = name; input.value = value;

          input.dataset.lahnaFilterState = '';

          this.form.append(input);

        }));

        this.form.requestSubmit();

      };

      this.form.addEventListener('change', this.onChange);

    }

    disconnectedCallback() { this.form?.removeEventListener('change', this.onChange); }

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-gallery-effects"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lahna-card-gallery')) {
    customElements.define('lahna-card-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.track = this.querySelector('.lahna-card-track');
        this.slides = Array.from(this.querySelectorAll('.lahna-card-slide'));
        this.controls = this.querySelector('.lahna-card-controls');
        if (!this.controls || !this.track) return;
        this.controls.hidden = false;
        this.previous = this.querySelector('[data-gallery-prev]');
        this.next = this.querySelector('[data-gallery-next]');
        this.dots = [...this.querySelectorAll('[data-gallery-dot]')];
        this.index = 0;
        this.update = () => {
          this.index = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / (this.track.clientWidth || 1))));
          const counter = this.querySelector('[data-gallery-index]');
          if (counter) counter.textContent = this.index + 1;
          if (this.previous) this.previous.disabled = this.index === 0;
          if (this.next) this.next.disabled = this.index === this.slides.length - 1;
          this.dots.forEach((dot, index) => dot.setAttribute('aria-pressed', String(index === this.index)));
          this.slides.forEach((slide, index) => { slide.tabIndex = index === this.index ? 0 : -1; });
        };
        this.go = (index) => this.track.scrollTo({ left: Math.max(0, Math.min(this.slides.length - 1, index)) * this.track.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        this.previous?.addEventListener('click', () => this.go(this.index - 1), {signal});
        this.next?.addEventListener('click', () => this.go(this.index + 1), {signal});
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), {signal}));
        this.track.addEventListener('scroll', this.update, {passive:true,signal});
        this.addEventListener('keydown', (event) => {
          if (!['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.go(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, {signal});
        this.track.addEventListener('pointerdown', (event) => {
          this.startX = event.clientX; this.startScroll = this.track.scrollLeft; this.moved = false;
          this.dragging = event.pointerType === 'mouse' && event.button === 0;
        }, {signal});
        this.track.addEventListener('pointermove', (event) => {
          if (this.startX == null) return;
          const distance = event.clientX - this.startX;
          if (Math.abs(distance) > 8) this.moved = true;
          if (this.dragging && this.moved) {
            if (!this.track.hasPointerCapture(event.pointerId)) this.track.setPointerCapture(event.pointerId);
            this.track.style.scrollSnapType = 'none';
            this.track.scrollLeft = this.startScroll - distance;
          }
        }, {signal});
        const finish = (event) => {
          if (this.dragging && this.moved) {
            const distance = event.clientX - this.startX;
            const step = Math.abs(distance) > 35 ? (distance < 0 ? 1 : -1) : 0;
            this.track.style.scrollSnapType = '';
            this.go(Math.round(this.startScroll / this.track.clientWidth) + step);
          }
          this.dragging = false; this.startX = null;
        };
        this.track.addEventListener('pointerup', finish, {signal});
        this.track.addEventListener('pointercancel', () => { this.dragging=false; this.startX=null; this.track.style.scrollSnapType=''; }, {signal});
        this.track.addEventListener('click', (event) => { if (this.moved && event.detail > 0) { event.preventDefault(); event.stopPropagation(); } }, {capture:true,signal});
        this.width = this.track.clientWidth;
        this.resize = new ResizeObserver(() => {
          const width = this.track.clientWidth;
          if (width && width !== this.width) {
            this.track.scrollTo({left:this.index * width,behavior:'instant'});
            this.width = width;
          }
          this.update();
        });
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); }
    });
  }
  if (!window.lahnaBookmarkAnimation) {
    window.lahnaBookmarkAnimation = true;
    document.addEventListener('lahna:cart-added', (event) => {
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const source = event.detail?.button;
      const target = document.querySelector('#cart-icon-bubble');
      if (!source || !target) return;
      const origin = source.getBoundingClientRect();
      const destination = target.getBoundingClientRect();
      const startX = Math.max(20, Math.min(innerWidth - 20, origin.x + origin.width / 2));
      const startY = Math.max(50, Math.min(innerHeight - 50, origin.y + origin.height / 2));
      const endX = Math.max(20, Math.min(innerWidth - 20, destination.x + destination.width / 2));
      const endY = Math.max(25, Math.min(innerHeight - 25, destination.y + destination.height / 2));
      const token = document.createElement('span');
      token.className = 'lahna-flying-bookmark'; token.setAttribute('aria-hidden','true'); token.textContent = '♡';
      token.style.left = `${startX - 13}px`; token.style.top = `${startY - 35}px`;
      document.body.append(token);
      const dx = endX - startX, dy = endY - startY;
      const motion = token.animate([
        {transform:'translate(0,0) rotate(-12deg) scale(.8)',opacity:0},
        {transform:`translate(${dx * .2}px,${dy * .2 - 45}px) rotate(14deg) scale(1)`,opacity:1,offset:.3},
        {transform:`translate(${dx}px,${dy}px) rotate(-15deg) scale(.18)`,opacity:0}
      ], {duration:760,easing:'cubic-bezier(.25,.65,.35,1)'});
      motion.finished.then(() => {
        token.remove();
        target.animate([{transform:'scale(1)'},{transform:'scale(1.15)'},{transform:'scale(1)'}], {duration:260});
      }).catch(() => token.remove());
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-localization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {

    if (event.target.closest('.lahna-mobile-shop')) {

      const drawer = document.querySelector('header-drawer');

      if (drawer?.mainDetailsToggle?.open) {

        drawer.closeMenuDrawer(event, drawer.mainDetailsToggle.querySelector('summary'));

      }

    }

    document.querySelectorAll('.lahna-localization[open]').forEach(panel => { if (!panel.contains(event.target)) panel.open = false; });

  });

  document.addEventListener('keydown', event => {

    if (event.key !== 'Escape') return;

    document.querySelectorAll('.lahna-localization[open]').forEach(panel => { panel.open = false; panel.querySelector('summary').focus(); });

  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-mobile-shortcuts"] && !Shopify.designMode) return;
  try {
    function lahnaMarkNavigation() {
    const current = new URL(location.href);
    document.querySelectorAll('.lahna-mobile-shortcuts a,.lahna-mobile-nav a.lahna-nav-button').forEach(link => {
      const target = new URL(link.href,location.origin);
      const samePath = target.pathname.replace(/\/$/,'') === current.pathname.replace(/\/$/,'');
      const sameSort = target.searchParams.get('sort_by') === current.searchParams.get('sort_by');
      const sameFilters = ['motif','couleur','univers'].every(key => target.searchParams.getAll(key).join(',') === current.searchParams.getAll(key).join(','));
      const sameTab = !target.hash || target.hash === (current.hash || '#revues-de-livres');
      if (samePath && sameSort && sameFilters && sameTab) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });
    requestAnimationFrame(() => {
      const rail = document.querySelector('.lahna-mobile-shortcuts');
      const active = rail?.querySelector('[aria-current="page"]');
      if (active && rail.clientWidth) {
        const offset = active.getBoundingClientRect().left - rail.getBoundingClientRect().left;
        rail.scrollLeft += offset - Math.max(0, (rail.clientWidth - active.offsetWidth) / 2);
      }
    });
  }
  lahnaMarkNavigation();
  document.addEventListener('shopify:section:load',lahnaMarkNavigation);
  window.addEventListener('hashchange',lahnaMarkNavigation);
  document.addEventListener('click',event => {
    const link = event.target.closest('.lahna-mobile-nav a[href]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const target = new URL(link.href,location.origin);
    if (target.pathname !== location.pathname || !target.hash) return;
    const drawer = link.closest('header-drawer');
    const toggle = drawer?.querySelector('details > summary');
    if (toggle && typeof drawer.closeMenuDrawer === 'function') drawer.closeMenuDrawer(event,toggle);
  });
  document.addEventListener('click',event => { if(event.target.closest('[data-journal-tab]')) requestAnimationFrame(lahnaMarkNavigation); });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-story-film"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lahna-story-film')) customElements.define('lahna-story-film', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const listen = (target,event,fn) => target.addEventListener(event,fn,{signal:this.abort.signal});
      this.button.hidden = false;
      listen(this.button,'click',() => { this.allowed = true; this.userPaused = !this.video.paused; this.sync(); });
      listen(this.video,'playing',() => { this.setAttribute('data-started',''); this.update(); });
      listen(this.video,'pause',() => { if (this.video.currentTime < .5) this.removeAttribute('data-started'); this.update(); });
      listen(document,'visibilitychange',() => this.sync());
      listen(this.reduced,'change',() => this.sync());
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.sync(); },{threshold:.2});
      this.observer.observe(this);
    }
    update() {
      const playing = !this.video.paused;
      this.button.setAttribute('aria-label',playing ? this.button.dataset.pause : this.button.dataset.play);
      this.button.setAttribute('aria-pressed',String(playing));
      this.button.querySelector('span').textContent = playing ? 'Ⅱ' : '▶';
    }
    sync() {
      if (!this.visible || document.hidden || this.userPaused || ((this.reduced.matches || navigator.connection?.saveData) && !this.allowed)) { this.video.pause(); return; }
      if (!this.video.getAttribute('src')) { this.video.src = this.video.dataset.src; this.video.muted = true; }
      this.video.play().catch(() => this.update());
    }
    disconnectedCallback() { this.video?.pause(); this.observer?.disconnect(); this.abort?.abort(); this.abort = null; }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lahna-ui-polish"] && !Shopify.designMode) return;
  try {
    function lahnaPolishActions() {
    document.querySelectorAll('.lahna-info-page .rte p').forEach(p => {
      const links = [...p.children];
      if (!links.length || !links.every(n => n.tagName === 'A')) return;
      const prose = [...p.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).map(n => n.textContent).join('').replace(/[\s·|–—-]/g,'');
      if (prose) return;
      p.classList.add('lahna-action-row');
      links.forEach(a => a.classList.add('lahna-action-button'));
      [...p.childNodes].filter(n => n.nodeType === Node.TEXT_NODE).forEach(n => n.remove());
    });
    document.querySelectorAll('.lahna-info-page .rte li > a[href*="instagram.com"],.lahna-info-page .rte li > a[href*="pinterest.com"],.lahna-info-page .rte li > a[href*="youtube.com"],.lahna-info-page .rte li > a[href*="tiktok.com"]').forEach(a => a.classList.add('lahna-action-button'));
  }
  lahnaPolishActions();
  document.addEventListener('shopify:section:load',lahnaPolishActions);
  } catch(e) { console.error(e); }
})();

})();
